import React from 'react';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';
import { Typography, Grid, Chip } from '@material-ui/core';

import { history } from '../../Routes/history';

import BackIcon from '../CustomIcons/BackIcon';
import ButtonWithIcon from '../Buttons/ButtonWithIcon';
import { ROUTE_NAMES } from '../../Routes/Routes';
import { requestTypes } from '../../Views/Requests/Utils/enums';
import { useCallback } from 'react';

const MeterInfoCard = props => {
  const classes = useStyles();

  const { meterSerial, balance, batteryLevel, time, id, className } = props;

  const handleHistoryClick = useCallback(() => {
    history.push(`${ROUTE_NAMES.requests}`, {
      type: requestTypes.prepaidMeterRecharge,
      meterSerial
    });
  }, [meterSerial]);

  return (
    <div id={id} className={clsx(classes.cardRoot, className)}>
      <Grid
        container
        className={clsx(classes.titleContainer, classes.cardContainer)}
      >
        <Typography className={classes.cardTitle}>Serial de Medidor</Typography>
        <Chip className={classes.serialChip} label={meterSerial} />
      </Grid>

      <Grid
        container
        className={clsx(classes.infoContainer, classes.cardContainer)}
      >
        <Typography className={classes.data}>
          <span className={classes.dataTitle}>Saldo:</span> {balance} metros
          cúbicos
        </Typography>
        <Typography className={classes.data}>
          <span className={classes.dataTitle}>Batería:</span> {batteryLevel} %
        </Typography>
        <Typography className={classes.data}>
          <span className={classes.dataTitle}>Fecha de última recarga:</span>{' '}
          {time}
        </Typography>
      </Grid>

      <Grid
        container
        justifyContent="flex-end"
        className={classes.cardContainer}
      >
        <ButtonWithIcon
          textClass={classes.details}
          buttonText={'Ver historial de recargas'}
          onClick={handleHistoryClick}
        >
          <BackIcon className={classes.detailsIcon} size={16} />
        </ButtonWithIcon>
      </Grid>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0
    },
    '100%': {
      opacity: 1
    }
  },
  cardRoot: {
    animation: `$fadeIn 250ms ${theme.transitions.easing.easeInOut}`,
    border: 'solid 1px',
    borderColor: theme.palette.background.border,
    borderRadius: theme.custom.borderRadius,
    backgroundColor: theme.palette.background.dark
  },
  cardContainer: {
    padding: theme.spacing(2),
    '&:not(:first-child):not(:last-child)': {
      backgroundColor: theme.palette.background.alternative
    }
  },
  titleContainer: {
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  cardTitle: {
    fontSize: 12,
    fontWeight: theme.typography.fontWeightBold
  },
  serialChip: {
    fontSize: 11,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    borderRadius: '10px',
    height: '24px'
  },
  label: {
    fontSize: 11,
    fontWeight: 500
  },
  infoContainer: {
    flexDirection: 'column',
    color: theme.palette.text.blackLight
  },
  data: {
    fontSize: 11,
    '&:not(:first-child)': {
      marginTop: theme.spacing(1)
    }
  },
  dataTitle: {
    fontWeight: 600
  },
  details: {
    color: theme.palette.primary.main,
    fontWeight: 600
  },
  divider: {
    margin: `${theme.spacing(2)}px 0`
  },
  detailsIcon: {
    transform: 'rotate(180deg)',
    fill: theme.palette.primary.main
  },
  footerDetails: {
    justifyContent: 'space-between',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'flex-end'
    }
  }
}));

export default MeterInfoCard;
